import { createAction } from 'redux-actions';

export const SET_SCHOOL_ID = 'SET_SCHOOL_ID';

const setSchoolId = createAction(SET_SCHOOL_ID);

export default {
    setSchoolId
};



// WEBPACK FOOTER //
// ./containers/overview/school-id-actions.js